var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "px-4 font-weight-bold soli-grey" }, [
      _vm._v(_vm._s(_vm.minLabel)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shell soli-round" }, [
      _vm.progress > 0
        ? _c(
            "div",
            {
              staticClass: "bar gradient-blue soli-round",
              style: { width: `${_vm.progress}%` },
            },
            [_c("span", [_vm._v(_vm._s(_vm.progress) + "%")])]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "px-4 font-weight-bold soli-grey" }, [
      _vm._v(_vm._s(_vm.maxLabel)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }